import Immutable from 'immutable';
import {
  ADMINISTRATIVE_CHECKLIST_PATH,
  AGENCY_INCIDENT_PATH,
  HOME_PATH,
  ITINERARY_INCIDENT_PATH,
  SUPERVISION_CONTROL_UNIT_PATH,
} from '../../../config/paths';

const INITIAL_STATE = Immutable.Map({
  cards: [
    {
      id: 'itinerary-incident',
      title: 'Incidentes de Itinerarios',
      path: ITINERARY_INCIDENT_PATH,
      icon: 'bus',
    },
    {
      id: 'agency-incident',
      title: 'Incidentes de Agencia',
      path: AGENCY_INCIDENT_PATH,
      icon: 'calendar-check-o',
    },
    {
      id: 'administrative-checklist',
      title: 'Checklist Administrativo',
      path: ADMINISTRATIVE_CHECKLIST_PATH,
      icon: 'check-square-o',
    },
  ],
  breadcrumbs: [
    {
      text: 'Inicio',
      tag: 'a',
      href: HOME_PATH,
    },
    {
      text: 'Gestión de Supervisión y Control',
      tag: 'span',
      href: SUPERVISION_CONTROL_UNIT_PATH,
    },
  ],
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
